import { render, staticRenderFns } from "./NotificationHandler.vue?vue&type=template&id=0a60bf7c&scoped=true&"
import script from "./NotificationHandler.vue?vue&type=script&lang=js&"
export * from "./NotificationHandler.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHandler.vue?vue&type=style&index=0&id=0a60bf7c&prod&scoped=true&lang=css&"
import style1 from "./NotificationHandler.vue?vue&type=style&index=1&id=0a60bf7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60bf7c",
  null
  
)

export default component.exports